import _ from 'lodash'
import { SearchTree, ValidateCharacters } from "../../../constants/ProConstants";

const BuildingValidator = ({model}, treeData)=>{     
    let errors = {};        
    if (_.isEmpty(model.location)) {           
        errors.location = "Please choose location.";
    }    
    if (_.isEmpty(model.name)) {                   
        errors.name = "Building name is required.";
    } 
    if (!_.isEmpty(model.name) && model.name.length > 120) {              
        errors.name = "Max 120 characters allowed";
    } 
    if (!_.isEmpty(model.name) && !ValidateCharacters(model.name)) {              
        errors.name = "Invalid Characters";
    } 
     
    if(_.get(model, "name") && treeData)  {       
        var element = SearchTree(treeData, "label", `${model.name}`, model.location.key)
        if(!_.isNull(element) && element.key !== model.key)
            errors.name =  "Building name already exists!";
        }
            
    if(!model.sameAsLocationAddress){  
        if(!_.get(model.address, "addressLine1")){
            errors.address =  "Address line field is required"
        }
        else if(!_.get(model.address, "city")){
            errors.address = "City field is required";
        }
        else if(!_.get(model.address, "state") || !_.get(model.address, "zipCode")  ){
            errors.address = "State and ZipCode field is required";
        }      
        
    } 
  
        return errors;

}

export default BuildingValidator;